<template>
  <v-card :loading="getDemoByIdLoading || currentLeadProductsLoading" class="align-stretch" height="100%">
    <template>
      <v-card-title>Demo</v-card-title>
    </template>

    <v-card-text>
      <v-row>
        <v-col>
          <p class="mb-1 text-caption">ID</p>
          <p class="display-1 accent--text">{{ getDemoProduct.id | customPlaceholder }}</p>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <p class="mb-1 text-caption">Status</p>
          <p><b>{{ getDemoProduct.status | customPlaceholder }}</b></p>
        </v-col>

        <v-col>
          <p class="mb-1 text-caption">Number</p>
          <p><b>{{ getDemoProduct.number.number | customPlaceholder }}</b></p>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <p class="mb-1 text-caption">Username</p>
          <p><b>{{ getDemoProduct.username | customPlaceholder }}</b></p>
        </v-col>

        <v-col>
          <p class="mb-1 text-caption">Password</p>
          <p><b>{{ getDemoProduct.password | customPlaceholder }}</b></p>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    computed: {
      ...mapGetters('leads', ['currentLeadProductsLoading']),
      ...mapGetters('demos', ['getDemoProduct', 'getDemoByIdLoading']),
    },
  }
</script>

<style lang="scss" scoped></style>
